module.exports = __webpack_public_path__ + "14e62b8b4012c3e6c88c672fc4b668ba.png";